var React = require('react');

function StoriesMeet (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .meet-green{fill:#569e79;}\n    ")),React.createElement("path",{"className":"meet-green","d":"M306.681,256.053,281.916,364.8,653.12,736V471.133L420.812,238.826Z","transform":"translate(-281.916 -238.826)","key":1})]);
}

StoriesMeet.defaultProps = {"width":"371.203","height":"497.179","viewBox":"0 0 371.203 497.179"};

module.exports = StoriesMeet;

StoriesMeet.default = StoriesMeet;
